import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import {
  initialFilter,
  ORGANIZATION_REPORT_STATUS
} from "./OrganizationReportUIHelpers";

const OrganizationReportUIContext = createContext();

export function useOrganizationReportUIContext() {
  return useContext(OrganizationReportUIContext);
}

export const OrganizationReportUIConsumer =
  OrganizationReportUIContext.Consumer;

export function OrganizationReportUIProvider({
  organizationReportUIEvents,
  children
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    newOrganizationReportButtonClick:
      organizationReportUIEvents.newOrganizationReportButtonClick,
    openEditOrganizationReportPage:
      organizationReportUIEvents.openEditOrganizationReportPage
  };

  return (
    <OrganizationReportUIContext.Provider value={value}>
      {children}
    </OrganizationReportUIContext.Provider>
  );
}
